export class DefaultMap extends Map {
    getDefaultValue;
    constructor(getDefaultValue, entries) {
        super(entries && [...entries]);
        if (typeof getDefaultValue !== 'function') {
            throw new TypeError('getDefaultValue should be a function');
        }
        this.getDefaultValue = getDefaultValue;
    }
    get(key) {
        if (this.has(key)) {
            return super.get(key);
        }
        const value = this.getDefaultValue(key);
        this.set(key, value);
        return value;
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibWFwLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2xpYi91dGlscy9tYXAudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsTUFBTSxPQUFPLFVBQWlCLFNBQVEsR0FBUztJQUNyQyxlQUFlLENBQWU7SUFFdEMsWUFBWSxlQUF3QixFQUFFLE9BQTBCO1FBQzlELEtBQUssQ0FBQyxPQUFPLElBQUksQ0FBQyxHQUFHLE9BQU8sQ0FBQyxDQUFDLENBQUE7UUFFOUIsSUFBSSxPQUFPLGVBQWUsS0FBSyxVQUFVLEVBQUUsQ0FBQztZQUMxQyxNQUFNLElBQUksU0FBUyxDQUFDLHNDQUFzQyxDQUFDLENBQUE7UUFDN0QsQ0FBQztRQUVELElBQUksQ0FBQyxlQUFlLEdBQUcsZUFBZSxDQUFBO0lBQ3hDLENBQUM7SUFFRCxHQUFHLENBQUMsR0FBTTtRQUNSLElBQUksSUFBSSxDQUFDLEdBQUcsQ0FBQyxHQUFHLENBQUMsRUFBRSxDQUFDO1lBQ2xCLE9BQU8sS0FBSyxDQUFDLEdBQUcsQ0FBQyxHQUFHLENBQU0sQ0FBQTtRQUM1QixDQUFDO1FBQ0QsTUFBTSxLQUFLLEdBQUcsSUFBSSxDQUFDLGVBQWUsQ0FBQyxHQUFHLENBQUMsQ0FBQTtRQUN2QyxJQUFJLENBQUMsR0FBRyxDQUFDLEdBQUcsRUFBRSxLQUFLLENBQUMsQ0FBQTtRQUNwQixPQUFPLEtBQUssQ0FBQTtJQUNkLENBQUM7Q0FDRiJ9